import AcquiringActionTypes from './acquiring-types'

const INITIAL_STATE = {
    error: null,
    errorMessage: null,
    success: null,
    loader: null,
    accountsAcquiring: null,
    defaultCardAcquiring: null,
    cardAcquiringMerchantsInit: null,
    cardAcquiringSettlements: null,
    cardAcquiringCharges: null,
    settlementsPdf: null,
    settlementsCSV: null,
    settlementsPeriodSummary: null,
    chargesReceiptPdf: null,
}

const AcquiringReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case AcquiringActionTypes.START_GET_DEFAULT_CARD_ACQUIRING:
            return {
                ...state,
                loader: { ...state.loader, GET_DEFAULT_CARD_ACQUIRING: true },
            }
        case AcquiringActionTypes.SUCCESS_GET_DEFAULT_CARD_ACQUIRING:
            return {
                ...state,
                loader: { ...state.loader, GET_DEFAULT_CARD_ACQUIRING: null },
                success: { ...state.success, GET_DEFAULT_CARD_ACQUIRING: true },
                defaultCardAcquiring: action.payload,
                error: null,
            }
        case AcquiringActionTypes.FAILURE_GET_DEFAULT_CARD_ACQUIRING:
            return {
                ...state,
                loader: { ...state.loader, GET_DEFAULT_CARD_ACQUIRING: null },
                success: { ...state.success, GET_DEFAULT_CARD_ACQUIRING: null },
                defaultCardAcquiring: null,
                error: true,
            }
        case AcquiringActionTypes.FINISH_GET_DEFAULT_CARD_ACQUIRING:
            return {
                ...state,
                loader: { ...state.loader, GET_DEFAULT_CARD_ACQUIRING: null },
                success: { ...state.success, GET_DEFAULT_CARD_ACQUIRING: null },
                error: null,
            }

        case AcquiringActionTypes.START_GET_ACCOUNTS_ACQUIRING:
            return {
                ...state,
                loader: { ...state.loader, GET_ACCOUNTS_ACQUIRING: true },
            }
        case AcquiringActionTypes.SUCCESS_GET_ACCOUNTS_ACQUIRING:
            return {
                ...state,
                loader: { ...state.loader, GET_ACCOUNTS_ACQUIRING: null },
                success: { ...state.success, GET_ACCOUNTS_ACQUIRING: true },
                accountsAcquiring: action.payload,
                error: null,
            }
        case AcquiringActionTypes.FAILURE_GET_ACCOUNTS_ACQUIRING:
            return {
                ...state,
                success: { ...state.success, GET_ACCOUNTS_ACQUIRING: null },
                loader: { ...state.loader, GET_ACCOUNTS_ACQUIRING: null },
                accountsAcquiring: null,
                error: true,
            }
        case AcquiringActionTypes.FINISH_GET_ACCOUNTS_ACQUIRING:
            return {
                ...state,
                loader: { ...state.loader, GET_ACCOUNTS_ACQUIRING: null },
                success: { ...state.success, GET_ACCOUNTS_ACQUIRING: null },
                error: null,
            }

        case AcquiringActionTypes.START_ACQUIRING_TRANSFERS_DOWNLOAD:
            return {
                ...state,
                loader: { ...state.loader, ACQUIRING_TRANSFERS_DOWNLOAD: true },
            }
        case AcquiringActionTypes.SUCCESS_ACQUIRING_TRANSFERS_DOWNLOAD:
            return {
                ...state,
                loader: { ...state.loader, ACQUIRING_TRANSFERS_DOWNLOAD: null },
                success: { ...state.success, ACQUIRING_TRANSFERS_DOWNLOAD: true },
                acquiringTransfersDownload: action.payload,
                error: null,
            }
        case AcquiringActionTypes.FAILURE_ACQUIRING_TRANSFERS_DOWNLOAD:
            return {
                ...state,
                success: { ...state.success, ACQUIRING_TRANSFERS_DOWNLOAD: null },
                loader: { ...state.loader, ACQUIRING_TRANSFERS_DOWNLOAD: null },
                acquiringTransfersDownload: null,
                error: true,
            }
        case AcquiringActionTypes.FINISH_ACQUIRING_TRANSFERS_DOWNLOAD:
            return {
                ...state,
                loader: { ...state.loader, ACQUIRING_TRANSFERS_DOWNLOAD: null },
                success: { ...state.success, ACQUIRING_TRANSFERS_DOWNLOAD: null },
                acquiringTransfersDownload: null,
                error: null,
            }

        case AcquiringActionTypes.START_CARD_ACQUIRING_MERCHANTS:
            return {
                ...state,
                loader: { ...state.loader, CARD_ACQUIRING_MERCHANTS: true },
            }
        case AcquiringActionTypes.SUCCESS_CARD_ACQUIRING_MERCHANTS:
            return {
                ...state,
                error: null,
                loader: { ...state.loader, CARD_ACQUIRING_MERCHANTS: null },
                success: { ...state.success, CARD_ACQUIRING_MERCHANTS: true },
                cardAcquiringMerchants: action.payload,
                cardAcquiringMerchantsInit: true,
            }
        case AcquiringActionTypes.FAILURE_CARD_ACQUIRING_MERCHANTS:
            return {
                ...state,
                success: { ...state.success, CARD_ACQUIRING_MERCHANTS: null },
                loader: { ...state.loader, CARD_ACQUIRING_MERCHANTS: null },
                error: true,
                cardAcquiringMerchants: null,
                cardAcquiringMerchantsInit: null,
            }
        case AcquiringActionTypes.FINISH_CARD_ACQUIRING_MERCHANTS:
            return {
                ...state,
                loader: { ...state.loader, CARD_ACQUIRING_MERCHANTS: null },
                success: { ...state.success, CARD_ACQUIRING_MERCHANTS: null },
                error: null,
                cardAcquiringMerchants: null,
                cardAcquiringMerchantsInit: null,
            }

        case AcquiringActionTypes.START_GET_CARD_ACQUIRING_SETTLEMENTS:
            return {
                ...state,
                loader: { ...state.loader, GET_CARD_ACQUIRING_SETTLEMENTS: true },
            }
        case AcquiringActionTypes.SUCCESS_GET_CARD_ACQUIRING_SETTLEMENTS:
            return {
                ...state,
                error: null,
                loader: { ...state.loader, GET_CARD_ACQUIRING_SETTLEMENTS: null },
                success: { ...state.success, GET_CARD_ACQUIRING_SETTLEMENTS: true },
                cardAcquiringSettlements: action.payload,
            }
        case AcquiringActionTypes.FAILURE_GET_CARD_ACQUIRING_SETTLEMENTS:
            return {
                ...state,
                success: { ...state.success, GET_CARD_ACQUIRING_SETTLEMENTS: null },
                loader: { ...state.loader, GET_CARD_ACQUIRING_SETTLEMENTS: null },
                error: true,
                cardAcquiringSettlements: null,
            }
        case AcquiringActionTypes.FINISH_GET_CARD_ACQUIRING_SETTLEMENTS:
            return {
                ...state,
                loader: { ...state.loader, GET_CARD_ACQUIRING_SETTLEMENTS: null },
                success: { ...state.success, GET_CARD_ACQUIRING_SETTLEMENTS: null },
                error: null,
                cardAcquiringSettlements: null,
            }

        case AcquiringActionTypes.START_GET_CARD_ACQUIRING_CHARGES:
            return {
                ...state,
                loader: { ...state.loader, GET_CARD_ACQUIRING_CHARGES: true },
            }
        case AcquiringActionTypes.SUCCESS_GET_CARD_ACQUIRING_CHARGES:
            return {
                ...state,
                error: null,
                loader: { ...state.loader, GET_CARD_ACQUIRING_CHARGES: null },
                success: { ...state.success, GET_CARD_ACQUIRING_CHARGES: true },
                cardAcquiringCharges: action.payload,
            }
        case AcquiringActionTypes.FAILURE_GET_CARD_ACQUIRING_CHARGES:
            return {
                ...state,
                success: { ...state.success, GET_CARD_ACQUIRING_CHARGES: null },
                loader: { ...state.loader, GET_CARD_ACQUIRING_CHARGES: null },
                error: true,
                cardAcquiringCharges: null,
            }
        case AcquiringActionTypes.FINISH_GET_CARD_ACQUIRING_CHARGES:
            return {
                ...state,
                loader: { ...state.loader, GET_CARD_ACQUIRING_CHARGES: null },
                success: { ...state.success, GET_CARD_ACQUIRING_CHARGES: null },
                error: null,
                cardAcquiringCharges: null,
            }

        case AcquiringActionTypes.START_ACQUIRING_CHARGES_DOWNLOAD:
            return {
                ...state,
                loader: { ...state.loader, ACQUIRING_CHARGES_DOWNLOAD: true },
            }
        case AcquiringActionTypes.SUCCESS_ACQUIRING_CHARGES_DOWNLOAD:
            return {
                ...state,
                error: null,
                loader: { ...state.loader, ACQUIRING_CHARGES_DOWNLOAD: null },
                success: { ...state.success, ACQUIRING_CHARGES_DOWNLOAD: true },
                cardAcquiringChargesDownload: action.payload,
            }
        case AcquiringActionTypes.FAILURE_ACQUIRING_CHARGES_DOWNLOAD:
            return {
                ...state,
                success: { ...state.success, ACQUIRING_CHARGES_DOWNLOAD: null },
                loader: { ...state.loader, ACQUIRING_CHARGES_DOWNLOAD: null },
                error: true,
                cardAcquiringChargesDownload: null,
            }
        case AcquiringActionTypes.FINISH_ACQUIRING_CHARGES_DOWNLOAD:
            return {
                ...state,
                loader: { ...state.loader, ACQUIRING_CHARGES_DOWNLOAD: null },
                success: { ...state.success, ACQUIRING_CHARGES_DOWNLOAD: null },
                error: null,
                cardAcquiringChargesDownload: null,
            }

        case AcquiringActionTypes.START_ACQUIRING_CREDENTIALS_REGENERATE:
            return {
                ...state,
                loader: { ...state.loader, ACQUIRING_CREDENTIALS_REGENERATE: true },
            }
        case AcquiringActionTypes.SUCCESS_ACQUIRING_CREDENTIALS_REGENERATE:
            return {
                ...state,
                error: null,
                loader: { ...state.loader, ACQUIRING_CREDENTIALS_REGENERATE: null },
                success: { ...state.success, ACQUIRING_CREDENTIALS_REGENERATE: true },
                cardAcquiringApiKey: action.payload.apiKey,
            }
        case AcquiringActionTypes.FAILURE_ACQUIRING_CREDENTIALS_REGENERATE:
            return {
                ...state,
                success: { ...state.success, ACQUIRING_CREDENTIALS_REGENERATE: null },
                loader: { ...state.loader, ACQUIRING_CREDENTIALS_REGENERATE: null },
                error: { ...state.error, ACQUIRING_CREDENTIALS_REGENERATE: true },
                errorMessage: action.payload.errorMessage,
            }
        case AcquiringActionTypes.FINISH_ACQUIRING_CREDENTIALS_REGENERATE:
            return {
                ...state,
                loader: { ...state.loader, ACQUIRING_CREDENTIALS_REGENERATE: null },
                success: { ...state.success, ACQUIRING_CREDENTIALS_REGENERATE: null },
                error: null,
                cardAcquiringApiKey: null,
            }

        case AcquiringActionTypes.START_SETTLEMENTS_PDF_DOWNLOAD:
            return {
                ...state,
                loader: { ...state.loader, SETTLEMENTS_PDF_DOWNLOAD: true },
            }
        case AcquiringActionTypes.SUCCESS_SETTLEMENTS_PDF_DOWNLOAD:
            return {
                ...state,
                error: null,
                settlementsPdf: action.payload,
                loader: { ...state.loader, SETTLEMENTS_PDF_DOWNLOAD: null },
                success: { ...state.success, SETTLEMENTS_PDF_DOWNLOAD: true },
            }
        case AcquiringActionTypes.FAILURE_SETTLEMENTS_PDF_DOWNLOAD:
            return {
                ...state,
                success: { ...state.success, SETTLEMENTS_PDF_DOWNLOAD: null },
                loader: { ...state.loader, SETTLEMENTS_PDF_DOWNLOAD: null },
                error: true,
            }
        case AcquiringActionTypes.FINISH_SETTLEMENTS_PDF_DOWNLOAD:
            return {
                ...state,
                loader: { ...state.loader, SETTLEMENTS_PDF_DOWNLOAD: null },
                success: { ...state.success, SETTLEMENTS_PDF_DOWNLOAD: null },
                error: null,
            }
        case AcquiringActionTypes.START_SETTLEMENT_PDF_DOWNLOAD:
            return {
                ...state,
                loader: { ...state.loader, SETTLEMENT_PDF_DOWNLOAD: true },
            }
        case AcquiringActionTypes.SUCCESS_SETTLEMENT_PDF_DOWNLOAD:
            return {
                ...state,
                error: null,
                settlementsPdf: action.payload,
                loader: { ...state.loader, SETTLEMENT_PDF_DOWNLOAD: null },
                success: { ...state.success, SETTLEMENT_PDF_DOWNLOAD: true },
            }
        case AcquiringActionTypes.FAILURE_SETTLEMENT_PDF_DOWNLOAD:
            return {
                ...state,
                success: { ...state.success, SETTLEMENT_PDF_DOWNLOAD: null },
                loader: { ...state.loader, SETTLEMENT_PDF_DOWNLOAD: null },
                error: true,
            }
        case AcquiringActionTypes.FINISH_SETTLEMENT_PDF_DOWNLOAD:
            return {
                ...state,
                loader: { ...state.loader, SETTLEMENT_PDF_DOWNLOAD: null },
                success: { ...state.success, SETTLEMENT_PDF_DOWNLOAD: null },
                error: null,
            }

        case AcquiringActionTypes.START_SETTLEMENTS_CSV_DOWNLOAD:
            return {
                ...state,
                loader: { ...state.loader, SETTLEMENTS_CSV_DOWNLOAD: true },
            }
        case AcquiringActionTypes.SUCCESS_SETTLEMENTS_CSV_DOWNLOAD:
            return {
                ...state,
                error: null,
                settlementsCSV: action.payload,
                loader: { ...state.loader, SETTLEMENTS_CSV_DOWNLOAD: null },
                success: { ...state.success, SETTLEMENTS_CSV_DOWNLOAD: true },
            }
        case AcquiringActionTypes.FAILURE_SETTLEMENTS_CSV_DOWNLOAD:
            return {
                ...state,
                success: { ...state.success, SETTLEMENTS_CSV_DOWNLOAD: null },
                loader: { ...state.loader, SETTLEMENTS_CSV_DOWNLOAD: null },
                error: true,
            }
        case AcquiringActionTypes.FINISH_SETTLEMENTS_CSV_DOWNLOAD:
            return {
                ...state,
                loader: { ...state.loader, SETTLEMENTS_CSV_DOWNLOAD: null },
                success: { ...state.success, SETTLEMENTS_CSV_DOWNLOAD: null },
                error: null,
            }

        case AcquiringActionTypes.START_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD:
            return {
                ...state,
                loader: { ...state.loader, SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD: true },
            }
        case AcquiringActionTypes.SUCCESS_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD:
            return {
                ...state,
                settlementsPeriodSummary: action.payload,
                error: null,
                loader: { ...state.loader, SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD: null },
                success: { ...state.success, SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD: true },
            }
        case AcquiringActionTypes.FAILURE_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD:
            return {
                ...state,
                success: { ...state.success, SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD: null },
                loader: { ...state.loader, SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD: null },
                error: true,
            }
        case AcquiringActionTypes.FINISH_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD:
            return {
                ...state,
                loader: { ...state.loader, SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD: null },
                success: { ...state.success, SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD: null },
                error: null,
            }

        case AcquiringActionTypes.START_CHARGES_RECEIPT_PDF:
            return {
                ...state,
                loader: { ...state.loader, CHARGES_RECEIPT_PDF: true },
            }
        case AcquiringActionTypes.SUCCESS_CHARGES_RECEIPT_PDF:
            return {
                ...state,
                chargesReceiptPdf: action.payload,
                error: null,
                loader: { ...state.loader, CHARGES_RECEIPT_PDF: null },
                success: { ...state.success, CHARGES_RECEIPT_PDF: true },
            }
        case AcquiringActionTypes.FAILURE_CHARGES_RECEIPT_PDF:
            return {
                ...state,
                success: { ...state.success, CHARGES_RECEIPT_PDF: null },
                loader: { ...state.loader, CHARGES_RECEIPT_PDF: null },
                error: true,
            }
        case AcquiringActionTypes.FINISH_CHARGES_RECEIPT_PDF:
            return {
                ...state,
                loader: { ...state.loader, CHARGES_RECEIPT_PDF: null },
                success: { ...state.success, CHARGES_RECEIPT_PDF: null },
                error: null,
            }

        case AcquiringActionTypes.START_PAYMENT_GATEWAY_MERCHANTS:
            return {
                ...state,
                loader: { ...state.loader, PAYMENT_GATEWAY_MERCHANTS: true },
            }
        case AcquiringActionTypes.SUCCESS_PAYMENT_GATEWAY_MERCHANTS:
            return {
                ...state,
                loader: { ...state.loader, PAYMENT_GATEWAY_MERCHANTS: null },
                success: { ...state.success, PAYMENT_GATEWAY_MERCHANTS: true },
                error: null,
            }
        case AcquiringActionTypes.FAILURE_PAYMENT_GATEWAY_MERCHANTS:
            return {
                ...state,
                loader: { ...state.loader, PAYMENT_GATEWAY_MERCHANTS: null },
                success: { ...state.success, PAYMENT_GATEWAY_MERCHANTS: null },
                error: true,
            }
        case AcquiringActionTypes.FINISH_PAYMENT_GATEWAY_MERCHANTS:
            return {
                ...state,
                loader: { ...state.loader, PAYMENT_GATEWAY_MERCHANTS: null },
                success: { ...state.success, PAYMENT_GATEWAY_MERCHANTS: null },
                error: null,
            }

        default:
            return state
    }
}

export default AcquiringReducer
